<div class="flex flex-col gap-medpace">
    @let expenseMaybe = expenseMaybe$ | async;
    <medpace-upload
        [inputFileId]="expenseMaybe?.attachmentId"
        [inputFile]="file$ | async"
        [downloadFileFn]="getDownloadExpenseAttachmentFn()"
        [acceptableTypes]="acceptableFileTypes"
        idVal="attachment-{{ index() }}"
        uploadButtonTitle="Upload Document"
        [attr.data-cy]="'fileDropzone'"
        (emitStuff)="onFileUploaded($event)"
        [displayMultipleFilesSizeExceeded]="true"
    />

    <div class="grid grid-cols-3 gap-medpace">
        <mds-datepicker
            id="TransactionDatePicker"
            data-cy="transactionDatePicker"
            [formCtrl]="expenseFormGroup().controls.receiptDate"
            appearance="outline"
            label="Receipt Date"
            [placeholder]="'Select date'"
        ></mds-datepicker>
        <mds-dropdown
            [filterable]="true"
            [closeOnPageScroll]="false"
            appearance="outline"
            label="Currency"
            placeholder="Select currency"
            [options]="(currencyOptions$ | async) ?? []"
            id="filterDropdown"
            [formCtrl]="expenseFormGroup().controls.currency"
        ></mds-dropdown>
    </div>
    <div class="grid grid-cols-3 gap-medpace">
        <mds-text-field
            appDisableMouseScroll
            id="AmountToAuthorizeField"
            data-cy="amountToAuthorizeField"
            [formCtrl]="formGrp().controls.requestedAmountInLocalCurrency"
            inputType="decimal"
            [decimalPlaces]="2"
            placeholder="Type here..."
            appearance="outline"
            [label]="requestedLabel$ | async"
        ></mds-text-field>
        @if (isInProcessOrHigherAndHasElevatedAccess$ | async) {
            <mds-text-field
                appDisableMouseScroll
                id="AuthorizedAmountField"
                data-cy="authorizedAmountField"
                [formCtrl]="formGrp().controls.authorizedAmountInLocalCurrency"
                inputType="decimal"
                [decimalPlaces]="2"
                placeholder="Type here..."
                appearance="outline"
                [label]="authorizedLabel$ | async"
            ></mds-text-field>
        }
    </div>
    @if (isInProcessOrHigherAndHasElevatedAccess$ | async) {
        <div class="flex flex-row gap-medpace">
            @if (authorizedAmountPatientsCurrencyChip()) {
                <mds-chip
                    [chips]="authorizedAmountPatientsCurrencyChip()"
                    [chipListType]="'basic'"
                    [multiple]="true"
                ></mds-chip>
            }
            @if (authorizedAmountUSDChip()) {
                <mds-chip [chips]="authorizedAmountUSDChip()" [chipListType]="'basic'" [multiple]="true"></mds-chip>
            }
        </div>
    }
</div>
